import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { LEGAL_UPDATED } from '../lib/legal';
import { SiteFooter } from './SiteFooter';
import { SiteHeader } from './ui';

/** Long-form page for the privacy policy and terms: readable line length, plain headings. */
export function LegalPage({
  title,
  summary,
  children,
}: {
  title: string;
  summary: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex min-h-dvh flex-col">
      <SiteHeader />
      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-10 sm:px-6 sm:py-14">
        <p className="text-xs font-bold tracking-[0.2em] text-muted uppercase">
          Last updated {LEGAL_UPDATED}
        </p>
        <h1 className="mt-3 text-3xl font-bold text-ink sm:text-4xl">{title}</h1>
        <div className="mt-6 rounded-2xl border border-line bg-card p-5 text-ink sm:p-6">
          <p className="text-sm font-bold">The short version</p>
          <div className="mt-2 text-sm leading-relaxed text-muted">{summary}</div>
        </div>
        <article className="legal mt-10">{children}</article>
        <p className="mt-12 text-sm text-muted">
          See also our{' '}
          <Link
            to="/privacy"
            className="font-semibold text-ink underline decoration-brand decoration-2 underline-offset-4"
          >
            Privacy Policy
          </Link>{' '}
          and{' '}
          <Link
            to="/terms"
            className="font-semibold text-ink underline decoration-brand decoration-2 underline-offset-4"
          >
            Terms of Service
          </Link>
          .
        </p>
      </main>
      <SiteFooter />
    </div>
  );
}
